import type { CSSProperties } from "react";
import { glowColors, isLight } from "@/shared/utils/color";
import type { ThemeColors } from "@/shell/theme";

/** Miniatura da Home de hoje pintada com um conjunto de cores: o menu e a
 *  barra do topo na cor do menu, emoldurando o painel de conteúdo; dentro
 *  dele a orbe na cor de destaque, o hero com o percentual grande, dois
 *  cartões de menção em vidro e a fileira dos indicadores com as cores dos
 *  cartões. Serve aos cartões do seletor e à pré-visualização do tema
 *  personalizado. */
export function ThemePreview({ colors, railImage }: { colors: ThemeColors; railImage?: string }) {
  // Mesma forma do `--rail-image` do tema: a imagem em quadrados, com um
  // véu da cor do menu por cima, e a cor por baixo.
  const rail = railImage
    ? `linear-gradient(rgb(6 8 28 / 25%), rgb(6 8 28 / 25%)), url("${railImage}") left top / 60px 60px repeat, ${colors.rail}`
    : colors.rail;
  // As luzes (orbe e degradê do percentual) usam as cores VIVAS da paleta,
  // nunca os cinzas dos cartões dos temas claros.
  const [glowA, glowB] = glowColors(colors.accent, [colors.card1, colors.card2, colors.card3]);
  const vars = {
    "--tp-glow-a": glowA,
    "--tp-glow-b": glowB,
    "--tp-rail": colors.rail,
    "--tp-accent": colors.accent,
    "--tp-card1": colors.card1,
    "--tp-card2": colors.card2,
    "--tp-card3": colors.card3,
    background: rail,
  } as CSSProperties;
  return (
    <div className={`theme-app-preview${isLight(colors.rail) ? " is-light-rail" : ""}`} style={vars} aria-hidden="true">
      <div className="tp-rail">
        <span className="tp-logo" />
        <span className="tp-nav is-active" />
        <span className="tp-nav" />
        <span className="tp-nav" />
      </div>
      <div className="tp-main">
        <div className="tp-topbar">
          <span className="tp-title" />
          <span className="tp-avatar" />
        </div>
        <div className="tp-panel">
          <span className="tp-orb" />
          <div className="tp-hero">
            <div className="tp-copy">
              <span className="tp-pill" />
              <span className="tp-pct" />
              <span className="tp-line" />
              <span className="tp-line is-short" />
            </div>
            <div className="tp-feed">
              <span className="tp-glass" />
              <span className="tp-glass" />
            </div>
          </div>
          <div className="tp-kpis">
            {(["card1", "card2", "card3"] as const).map(key => (
              <span key={key} className="tp-kpi" style={{ "--tp-tint": colors[key] } as CSSProperties}>
                <i />
              </span>
            ))}
            <span className="tp-kpi is-dark"><i /></span>
          </div>
        </div>
      </div>
    </div>
  );
}
